import React from "react"
//import I18n from "i18n-js/index.js.erb"
import NightAuditFolioItemsSummary from "../NightAuditFolioItems/NightAuditFolioItemsSummary"
import NightAuditPaymentsSummary from "../NightAuditPayments/NightAuditPaymentsSummary"

class NightAuditConfirmation extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return(
      <div>
        <div className="jumbotron" style={{ paddingTop: 15, paddingBottom: 15}}>
          <h4 className="text-center"><strong>{I18n.t('night_audit_run_successfully')}</strong></h4>
        </div>
        <NightAuditFolioItemsSummary {...this.props} />
        <NightAuditPaymentsSummary {...this.props} />
        {this.renderAuthConfirmation()}
        {this.rendernNoShowConfirmation()}
      </div>
    );
  };

  renderAuthConfirmation(){
    return(
      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text">{I18n.t("authorizations")}</h3>
          {
            this.props.confirmationResponse && this.props.confirmationResponse.auth_segments && this.props.confirmationResponse.auth_segments.deposit_reauth_authorized_payments && this.props.confirmationResponse.auth_segments.deposit_reauth_authorized_payments.length
            ?
            <div className="row container">
              <div className="col-md-12">
                <ul style={{ marginTop: 10, paddingLeft: 20 }}>
                    <li><label>{this.props.confirmationResponse.auth_segments.deposit_reauth_authorized_payments.length} {I18n.t('room_incidental_deposit_authorized')}</label></li>
                </ul>
              </div>
            </div>
            :
            null
          }
          {
            this.props.confirmationResponse && this.props.confirmationResponse.auth_segments && this.props.confirmationResponse.auth_segments.deposit_reauth_authorize_failed && this.props.confirmationResponse.auth_segments.deposit_reauth_authorize_failed.length
            ?
            <div className="row container">
              <div className="col-md-12">
                <ul style={{ paddingLeft: 20 }}>
                    <li><label>{this.props.confirmationResponse.auth_segments.deposit_reauth_authorize_failed.length} {I18n.t('room_incidental_deposit_auths_failed')}</label></li>
                </ul>
              </div>
            </div>
            :
            null
          }
          {
            this.props.confirmationResponse && this.props.confirmationResponse.check_in_cc_auths && this.props.confirmationResponse.check_in_cc_auths.check_in_auths && this.props.confirmationResponse.check_in_cc_auths.check_in_auths.length
            ?
            <div className="row container">
              <div className="col-md-12">
                <ul style={{ paddingLeft: 20 }}>
                  <li><label>{this.props.confirmationResponse.check_in_cc_auths.check_in_auths.length} {I18n.t('room_check_in_authorized')}</label></li>
                </ul>
              </div>
            </div>
            :
            null
          }
          {
            this.props.confirmationResponse && this.props.confirmationResponse.check_in_cc_auths && this.props.confirmationResponse.check_in_cc_auths.failed_cc_check_in && this.props.confirmationResponse.check_in_cc_auths.failed_cc_check_in.length
            ?
            <div className="row container">
              <div className="col-md-12">
                <ul style={{ paddingLeft: 20 }}>
                    <li><label>{this.props.confirmationResponse.check_in_cc_auths.failed_cc_check_in.length} {I18n.t('room_check_in_authorized_failed')}</label></li>
                </ul>
              </div>
            </div>
            :
            null
          }
        </div>
      </div>
    );
  };

  rendernNoShowConfirmation(){
    return(
      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text">{I18n.t("no_shows")}</h3>
          <div className="row container">
            <div className="col-md-12">
              <ul style={{ paddingLeft: 20 }}>
                <li><label>{this.props.confirmationResponse && this.props.confirmationResponse.no_show_segments && this.props.confirmationResponse.no_show_segments.updated_segments && this.props.confirmationResponse.no_show_segments.updated_segments.length ? this.props.confirmationResponse.no_show_segments.updated_segments.length : 0} {I18n.t('rooms_updated')}</label></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

};

export default NightAuditConfirmation